import styled from 'styled-components';

const ButtonStyle = styled.div`
	--btnPadTB: var(--sp2-5x);
	--btnPadLR: var(--sp6x);
	--btnBorderRadius: var(--sp1-5x);

	&.btn {
		width: fit-content;
		overflow: hidden;
		cursor: pointer;
		will-change: transform;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					animation: none;
					animation: scaleYoyo 0.44s ease-in-out forwards;
				}
			}
		}

		a,
		button {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: var(--btnPadTB) var(--btnPadLR);
			color: var(--white1000);
			font-size: var(--p1);
			font-family: var(--montserrat_arm);
			font-weight: 500;
			line-height: var(--lineHeightL);
			background-color: var(--red1000);
			border-radius: var(--btnBorderRadius);
			border: 1px solid var(--red1000);
			transition: all var(--trTime) ease-out;
			cursor: pointer;
		}

		&.secondary {
			a,
			button {
				background-color: var(--white1000);

				/* color: var(--black1000);
				border: 1px solid var(--black1000); */

				color: var(--red1000);
				border: 1px solid var(--red1000);
			}
		}

		&.secondary-transparent {
			a,
			button {
				color: var(--black1000);
				background-color: transparent;
				border: 1px solid var(--black1000);
			}
		}

		&.third {
			a,
			button {
				color: var(--red1000);
				background-color: var(--white1000);
				border: 1px solid var(--white1000);
			}
		}

		&.primary-not-anim {
			overflow: unset !important;
			will-change: unset !important;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						animation: unset !important;
						animation: unset !important;
					}
				}
			}

			a,
			button {
				transition: all var(--trTime) ease-out;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							color: var(--red1000);
							background-color: var(--white1000);
							border: 1px solid var(--red1000);
						}
					}
				}
			}

			&.disabled {
				a,
				button {
					background-color: var(--gray400);
					border: 1px solid var(--gray400);
					color: var(--white1000);
				}
			}
		}

		&.underline-version {
			overflow: unset !important;
			will-change: unset !important;

			a,
			button {
				padding: unset !important;
				color: var(--red1000);
				background-color: unset !important;
				border-radius: unset !important;
				border: unset !important;
				transition: unset !important;
				text-decoration-line: underline;
				text-decoration-style: solid;
				text-decoration-skip-ink: none;
				text-decoration-thickness: auto;
				text-underline-offset: auto;
				text-underline-position: from-font;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							text-decoration-line: none;
						}
					}
				}
			}

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						animation: unset !important;
						animation: unset !important;
					}
				}
			}
		}

		&.disabled {
			pointer-events: none;

			a,
			button {
				pointer-events: none;
			}
		}
	}

	/* //! Animation */
	@keyframes scaleYoyo {
		0% {
			transform: scale(1);
		}
		45% {
			transform: scale(1.08);
		}
		100% {
			transform: scale(1);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--btnPadTB: var(--sp2x);
		--btnPadLR: var(--sp5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--btnPadTB: 14px;
		--btnPadLR: var(--sp4x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--btnPadTB: var(--sp1-5x);
		--btnPadLR: var(--sp3x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default ButtonStyle;
